import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function GalleryUpdate() {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);

  // const API_BASE = "http://localhost/myapp-ks/api";
  const API_BASE = "https://peralassery.cubixsystems.com/myapp/api";

  // Fetch categories
  useEffect(() => {
    axios.get(`${API_BASE}/fetch_categories.php`)
      .then(res => setCategories(Array.isArray(res.data) ? res.data : []));
  }, []);

  // Fetch images
  useEffect(() => {
    axios.get(`${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`)
      .then(res => setImages(Array.isArray(res.data) ? res.data : []));
  }, [activeCategory]);

  // Toggle checkbox
  const toggleSelect = (id) => {
    setSelectedImages(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  // Delete selected images
  const deleteSelectedImages = async () => {
    if (selectedImages.length === 0) {
      alert("Select images to delete");
      return;
    }

    if (!window.confirm("Delete selected images permanently?")) return;

    await axios.post(`${API_BASE}/delete_images.php`, {
      image_ids: selectedImages
    });

    setImages(images.filter(img => !selectedImages.includes(img.id)));
    setSelectedImages([]);
  };

  // 🔴 DELETE ALL IMAGES IN CATEGORY
  const deleteAllImages = async () => {
    if (activeCategory === "all") {
      alert("Select a category first");
      return;
    }

    if (!window.confirm("Delete ALL images in this category permanently?")) return;

    await axios.post(`${API_BASE}/delete_all_images.php`, {
      category_id: activeCategory
    });

    setImages([]);
    setSelectedImages([]);
  };

  // Upload images
  const uploadImages = async () => {
    if (activeCategory === "all") {
      alert("Select a category first");
      return;
    }

    if (uploadFiles.length === 0) {
      alert("Select images to upload");
      return;
    }

    const formData = new FormData();
    formData.append("category_id", activeCategory);

    for (let file of uploadFiles) {
      if (file.size > 1024 * 1024) {
        alert(`${file.name} exceeds 1 MB`);
        return;
      }
      formData.append("images[]", file);
    }

    await axios.post(`${API_BASE}/add_gallery.php`, formData);

    setUploadFiles([]);
    document.getElementById("fileInput").value = "";

    const res = await axios.get(`${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`);
    setImages(Array.isArray(res.data) ? res.data : []);
  };

  return (
    <div className="gallery-container">

      {/* CATEGORY FILTER */}
      <div className="category-tabs">
        <button
          className={activeCategory === "all" ? "active" : ""}
          onClick={() => setActiveCategory("all")}
        >
          Show All
        </button>

        {categories.map(cat => (
          <button
            key={cat.id}
            className={activeCategory === cat.id ? "active" : ""}
            onClick={() => setActiveCategory(cat.id)}
          >
            {cat.category_name}
          </button>
        ))}
      </div>

      {/* ACTION BUTTONS */}
      <div className="gallery-actions">
        <button onClick={deleteSelectedImages} className="delete-btn">
          Delete Selected
        </button>

        {activeCategory !== "all" && (
          <>
            <button onClick={deleteAllImages} className="delete-btn danger">
              Delete All
            </button>

            <input
              style={{color:'black'}}
              id="fileInput"
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => setUploadFiles([...e.target.files])}
            />
            <button onClick={uploadImages} className="upload-btn">
              Upload Images
            </button>
          </>
        )}
      </div>

      {/* IMAGE GRID */}
      <div className="gallery-grid" style={{height:'400px',overflow:'auto'}}>
        {images.length === 0 ? (
          <p>No images found</p>
        ) : (
          images.map(img => (
            <div className="gallery-item" key={img.id}>
              <input
                type="checkbox"
                checked={selectedImages.includes(img.id)}
                onChange={() => toggleSelect(img.id)}
              />
              <img
                src={`https://peralassery.cubixsystems.com/myapp/uploads/gallery/${img.image_name}`}
                alt=""
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
